import vbBookIndex from "../views/book/vb-book-index-v2";
import Detail from "../views/book/Detail.vue";

export default [
  {
    path: "/app/:userDeptRoleId/quanlySoDen/:bookType",
    name: "quanlySoDen",
    component: vbBookIndex
  },
  {
    path: "/app/:userDeptRoleId/quanlySoDen/:bookType/edit/:id",
    name: "quanlySoDenDetail",
    components: {
      default: vbBookIndex,
      detail: Detail
    }
  },
  {
    path: "/app/:userDeptRoleId/quanlySoDi/:bookType",
    name: "quanlySoDi",
    component: vbBookIndex
  },
  {
    path: "/app/:userDeptRoleId/quanlySoDiDetail/:bookType/edit/:id",
    name: "quanlySoDiDetail",
    components: {
      default: vbBookIndex,
      detail: Detail
    }
  },
  {
    path: "/app/:userDeptRoleId/bookso",
    name: "bookSo",
    component: () => import("../views/book/VbBookDocindex")
  }
];



// WEBPACK FOOTER //
// ./src/router/book.js